import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { categories } from '../../../../../redux/categories/action';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { products } from '../../../../../redux/products/action';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectListItems } from '../../../../../redux/library/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectMarketPlacePolicyQueryByEntityItems, selectMarketPlacePolicyQueryItems } from '../../../../../redux/market-place-policies/selector';
import { marketPlacePolicy } from '../../../../../redux/market-place-policies/action';
import { vendors } from '../../../../../redux/vendors/action';
import { selectVendorsListItems } from '../../../../../redux/vendors/selector';
import { tags } from '../../../../../redux/tags/action';
import { customers } from '../../../../../redux/customers/action';
import { selectTagsListItems } from '../../../../../redux/tags/selector';
import { selectCustomersListItems } from '../../../../../redux/customers/selector';
import { selectProductListItems } from '../../../../../redux/products-summary/selector';
import MarketPlacePolicyComponent from '../components/market-place-policy.component';
import { setDisplayText } from '../../../../../service/tag-names.service';


let currentChange: any = {}
const MarketPlacePolicy = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectMarketPlacePolicyQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const vendorsList = useSelector(selectVendorsListItems);
  const productsLists = useSelector(selectProductListItems)
  const customerLists = useSelector(selectCustomersListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const collctionsEntityTypeLists = useSelector(selectMarketPlacePolicyQueryByEntityItems) 
  const [productsListData, setProductsListData] = useState<any>([]);
const [isQuery, setIsQuery] = useState<boolean>(false)

const [
  columnDefs,
  setColumnDefs
] = useState({});
const [
  selectedMarketPlacePolicy,
  setSelectedMarketPlacePolicy
] = useState<any>({
  LimitedToOrganizationUnitIds: [],
  Inclusions: {
  },
  Exclusions: {
  },
  MediaMappings: {
    MediaFiles: [],
    Templates: []
  },
  Marketplaces: {
    EntityTypeId: 0,
    EntityIds: []
  },
  IsActive: true
})

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const [
    programImageIndex,
    setprogramImageIndex
  ] = useState<any>([])
  const fetchProgramyId= ()=>{
    dispatch(marketPlacePolicy.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/marketplace/marketplace-policies/query`,entity:'marketPlacePolicy',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
}).then(()=>{
  setIsLoading(false)
})
  }

  console.log(collctionsEntityTypeLists,'collctionsEntityTypeLists')
  const fetchCollectionPolicyByEntity = async () => {

    await dispatch(marketPlacePolicy.queryByEntityType({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/marketplace/marketplace-policies/query-by-entity-type`,
      entity: 'marketPlacePolicy',
      jsonData: {
        Records: [
          {
            EntityTypeId: queryItems?.result?.items.MarketplaceTypeId,
            "Id": parmas?.id
          }
        ]
      }
    }))
  };

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'EntityTypeName', headerName: 'EntityType Name' },
      { field: 'EntityName', headerName: 'Entity Name' }
    ]);
  }


  useEffect(
    () => {
      dispatch(tags.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tags',
        jsonData: {}
      })).then(() => {
      dispatch(vendors.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/fetch`, entity: 'vendors', jsonData: {
          "Context": {},
          "Records": [
              {
                  "IsTenantBased": false,
                  "IsDBNBased": false,
                  "IsBothTenantANDDBNBased": false

              }
],
"Pagination":{
  "PageNumber": 1,
  "PageSize": 100,
  "SortField": "OrgRegistryId",
  "SortOrder": "desc"
}
      }
      }))})
     .then(()=>{
      dispatch(products.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/csp/fetch`,entity:'products',jsonData:{ }}))
    }).then(()=>{
        dispatch(customers.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/list`,
          entity: 'customers',
          jsonData: {}
        }));
      }).then(()=>{
      dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}}))
    }).then(()=>{
      if (parmas?.id > 0) {
        fetchProgramyId()
        setIsLoading(false)
      }
      else{
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
      if (isQuery) {
     
         // Create a copy of   selectedMarketPlacePolicy and modify the copy
      const updatedCollections = {
        ...queryItems?.result?.items,
        Marketplaces: {
          ...queryItems?.result?.items.Marketplaces,
          EntityIds: []  // Reset EntityIds immutably
        }
      };
      setSelectedMarketPlacePolicy(updatedCollections)
      createColumnDefs();
      fetchCollectionPolicyByEntity();

        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )


  const fetchMappedCollections = async ({ event }: any) => {
    event.preventDefault();
      selectedMarketPlacePolicy.Marketplaces.EntityTypeId =selectedMarketPlacePolicy.MarketplaceTypeId
    dispatch(marketPlacePolicy.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/marketplace/marketplace-policies`,
      entity: 'marketPlacePolicy',
      jsonData: {
        Records: [
            selectedMarketPlacePolicy
        ]
      }
    }))
      selectedMarketPlacePolicy.Marketplaces.EntityIds = []
    fetchCollectionPolicyByEntity()
  }

  // const handleDelete = (data: any) => {
  //   dispatch(marketPlacePolicy.delete({
  //     url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/organization/csp/collections/delete-collections`,
  //     entity: 'marketPlacePolicy',
  //     jsonData: {
  //       Context: {},
  //       Records: [
  //         {
  //           Id: data?.Id
  //         }
  //       ]
  //     }
  //   })).then(() => {
  //     fetchCollectionPolicyByEntity()
  //   })
  // }

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field, idx: 0 }
    setSelectedMarketPlacePolicy({ ...selectedMarketPlacePolicy, [field]: value })
  }

  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedMarketPlacePolicy({ ...selectedMarketPlacePolicy, [fields[0]]: valueData });
  }
 
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
    
      OwnerId: parmas?.id,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setprogramImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'marketplacepolicy',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[programImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
 
  const handleFormMediaChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
      mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )
      console.log(selectedMarketPlacePolicy,'selectedMarketPlacePolicy')
      const programData ={
        "Id": selectedMarketPlacePolicy?.Id,
        "IsActive": selectedMarketPlacePolicy?.IsActive,
          "Name": selectedMarketPlacePolicy?.Name,
          "Description": selectedMarketPlacePolicy?.Description,
          "StartDateUtc": selectedMarketPlacePolicy?.StartDateUtc,
          "EndDateUtc": selectedMarketPlacePolicy?.EndDateUtc,
          "Remarks": selectedMarketPlacePolicy?.Remarks,
          "MarketplaceTypeId": selectedMarketPlacePolicy?.MarketplaceTypeId,
          "DisplayOrder": selectedMarketPlacePolicy?.DisplayOrder,
          "Inclusions": selectedMarketPlacePolicy?.Inclusions,
          "Exclusions": selectedMarketPlacePolicy?.Exclusions,
          "LimitedToOrganizationUnitIds": selectedMarketPlacePolicy?.LimitedToOrganizationUnitIds,
          "MediaMappings": {
            "MediaFiles": mediaFiles,
            "Templates": []
          },
          "Marketplaces":
            {
              "EntityTypeId": selectedMarketPlacePolicy?.MarketplaceTypeId || 0,
              EntityIds: selectedMarketPlacePolicy?.Marketplaces?.EntityIds || 0
            }
      }
    if (parmas?.id > 0) {
     
 
     dispatch(marketPlacePolicy.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/marketplace/marketplace-policies`,entity:'marketPlacePolicy',jsonData:{
          
    Records: [
      programData
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      dispatch(marketPlacePolicy.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/marketplace/marketplace-policies`,entity:'marketPlacePolicy',jsonData:{
          
      Records: [
        programData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/agencies/policies/marketpolicy')
} 
useEffect(() => {
  // console.log('productsLists', productsLists)
  if (productsLists?.result?.items && productsLists?.result?.items?.length > 0) {
    const products = _.map(productsLists?.result?.items, (item: any) => {
      return item
    })
    console.log('products list', products)
    setProductsListData(products)
  }
}, [productsLists]);

useEffect(() => {
  if (tagsLists?.isLoading ||
    
    productsLists?.isLoading ||
    customerLists?.isLoading ||
    organizationUnitsLists?.isLoading ||
    queryItems?.isLoading ||
    collctionsEntityTypeLists?.isLoading 
   
  ) {
    setIsLoading(true)
  } else {
    setIsLoading(false)
  }
  // console.log('vendorsList', vendorsList, 'categoriesLists', categoriesLists)
}, [tagsLists,  productsLists, customerLists, organizationUnitsLists, queryItems, collctionsEntityTypeLists]);

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationmediaInfo()
      }
    },
    [mediaFiles]
  )
  useEffect(
    () => {

    },
    [selectedMarketPlacePolicy]
  )
 console.log(collctionsEntityTypeLists,'collctionsEntityTypeLists') 
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
     {isLoading ? <PageLoader /> : 
          <MarketPlacePolicyComponent 
          changeImage={changeImage}
          handleClose={handleClose}
          mediaFiles={mediaFiles}
          onFormChange={handleFormChange}
          onFormItemChange={handleFormMediaChange}
          onFormSubmit={handleFormSubmit}
          selectedProgram={selectedMarketPlacePolicy}
          back={back}
          entityTypes={libraryData?.result?.EntityTypes}
          vendors={vendorsList?.result?.items}
         products = {productsLists?.result?.items}
         id={parmas?.id}
         onInnerFormChange={handleInnerFormChange}
         organizationUnits={organizationUnitsLists?.result?.items}
         allTags={setDisplayText(tagsLists?.result?.items)}
         customers={customerLists?.result?.items}
         fetchMappedCollections={fetchMappedCollections}
         rowData={collctionsEntityTypeLists?.result?.items}
         columnDefs={columnDefs}
         setSelectedPolicyCollections={setSelectedMarketPlacePolicy}
       
          />  }
          </>
    )
}
export default MarketPlacePolicy;